import {maxLengthValidator, minLengthValidator, requiredValidator} from 'modules/Forms/helpers/fieldValidation';
import { FIELDS_RENDER_METHOD } from 'modules/Forms/constants/FieldsRenderMethod.constants';

export const ADDRESS_FORM_FIELDS = {
  ZIP: 'zipCode',
  STREET: 'streetAddress',
  NUMBER: 'number',
  COMPLEMENT: 'complement',
  DISTRICT: 'district',
  CITY: 'city',
  STATE: 'state',
};

export const ADDRESS_SUBSECTION = {
  title: 'Novo endereço',
  fields: [
    {
      id: ADDRESS_FORM_FIELDS.ZIP,
      mask: '99999-999',
      validators: [requiredValidator, minLengthValidator(8), maxLengthValidator(10)],
      type: 'text',
      placeholder: 'CEP',
      renderMethod: FIELDS_RENDER_METHOD.PARTIAL_WIDTH_SINGLE,
      maxLength: 9,
      isRequired: true,
    },
    {
      id: ADDRESS_FORM_FIELDS.STREET,
      validators: [requiredValidator, minLengthValidator(3), maxLengthValidator(100)],
      type: 'text',
      placeholder: 'Logradouro',
      renderMethod: FIELDS_RENDER_METHOD.PARTIAL_WIDTH_WIDE,
      isRequired: true,
    },
    {
      id: ADDRESS_FORM_FIELDS.NUMBER,
      validators: [requiredValidator, minLengthValidator(1), maxLengthValidator(10)],
      type: 'text',
      placeholder: 'Número',
      renderMethod: FIELDS_RENDER_METHOD.PARTIAL_WIDTH_COMPACT,
      isRequired: true,
    },
    {
      id: ADDRESS_FORM_FIELDS.COMPLEMENT,
      validators: [requiredValidator, minLengthValidator(3), maxLengthValidator(100)],
      type: 'text',
      placeholder: 'Complemento',
      renderMethod: FIELDS_RENDER_METHOD.PARTIAL_EQUAL,
      isRequired: false,
    },
    {
      id: ADDRESS_FORM_FIELDS.DISTRICT,
      validators: [requiredValidator, minLengthValidator(3), maxLengthValidator(100)],
      type: 'text',
      placeholder: 'Bairro',
      renderMethod: FIELDS_RENDER_METHOD.PARTIAL_EQUAL,
      isRequired: true,
    },
   {
      id: ADDRESS_FORM_FIELDS.CITY,
      validators: [requiredValidator, minLengthValidator(3), maxLengthValidator(100)],
      type: 'text',
      placeholder: 'Cidade',
      renderMethod: FIELDS_RENDER_METHOD.PARTIAL_WIDTH_WIDE,
     isRequired: true,
    },
    {
      id: ADDRESS_FORM_FIELDS.STATE,
      validators: [requiredValidator, minLengthValidator(2), maxLengthValidator(100)],
      type: 'text',
      placeholder: 'UF',
      renderMethod: FIELDS_RENDER_METHOD.PARTIAL_WIDTH_COMPACT,
      isRequired: true,
    },
  ],
};
